import * as yup from 'yup';

export const invitationFormSchema = yup.object().shape({
  percent: yup.lazy((value) => {
    if (value === null || value === '') {
      return yup.string();
    }

    return yup
      .number()
      .transform((value) => (isNaN(value) ? null : value))
      .nullable();
  }),
  roundup: yup.boolean(),
  roundupType: yup.string().nullable(),
  roundupThreshold: yup.lazy((value) => {
    if (value === null || value === '' || value === undefined) {
      return yup.mixed().nullable();
    }

    return yup
      .number()
      .transform((value) => (isNaN(value) ? null : value))
      .min(0, 'providers_settings.round_up_threshold_min')
      .nullable();
  }),
});
